import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { registerCard } from '@chess/api-dashboard';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import { HELP_API, type Help } from '@chess/api-help';
import { ENDING_RESULTS_HELP, endingResultsHelp } from './help.tsx';
import '@chess/api-insights/charts.css';
import { EndingResultsCard, TITLE } from './EndingResultsCard.tsx';
import { EndingResultsAggregator } from './EndingResultsAggregator.ts';

// Ending card "Ending results": registers its aggregator with the game store
// and renders `EndingResultsCard` first among the Ending section's top cards
// (`home.section.ending`, order 4, before Your losses and Score through the
// ending), which Home's Ending section and the Ending screen both show.
// Slices open the library filtered to those games (`libraryLink`, last 30
// days).
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new EndingResultsAggregator();
  registerAggregator(getApi, aggregator);
  void app.getApi<Help>(HELP_API).then((help) => help.register(ENDING_RESULTS_HELP, endingResultsHelp));
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <EndingResultsCard loading />;
    return result ? <EndingResultsCard result={result} link={link} /> : null;
  };
  registerCard(app, 'home.section.ending', Card, { order: 4, title: TITLE, help: ENDING_RESULTS_HELP });
}
